import { PortfolioItem } from 'portfolio/PortfolioItem';
import {
    PortfolioSummaryAggregatedData,
    PortfolioSummaryAggregatedDataGroup,
} from 'widgets/portfolioSummary/store/data/PortfolioSummaryDataState';
import { AggregationField } from '../fields/aggregationFieldPortfolio';

export interface PortfolioSummarySortableDataItem {
    groupName: string;
    orderedValueLoc: number;
}

export interface AggregationStrategy {
    aggregationField: AggregationField;
    combineSellsAndShorts: boolean;

    initialiseAggregatedData(): PortfolioSummaryAggregatedData;

    getAggregationGroup(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ): PortfolioSummaryAggregatedDataGroup;

    sort(
        x: PortfolioSummarySortableDataItem,
        y: PortfolioSummarySortableDataItem
    ): number;

    filterPortfolio(
        filteredPortfolio: PortfolioItem[],
        groupName: string
    ): PortfolioItem[];

    getDrillDowns(
        data: PortfolioSummaryAggregatedData,
        item: PortfolioItem
    ): { [drillDownField: string]: PortfolioSummaryAggregatedData } | undefined;

    groupNameToValue: (groupName: string) => string;
}

export const SidesGroupName = 'sides';
export const TotalGroupName = 'Total';
export const NetGroupName = 'Net';
export const BuyGroupName = 'Buy';
export const SellGroupName = 'Sell';
export const ShortGroupName = 'Short';
